import { render, staticRenderFns } from "./SH050ShopperPayDetails.vue?vue&type=template&id=2e472951&"
import script from "./SH050ShopperPayDetails.vue?vue&type=script&lang=js&"
export * from "./SH050ShopperPayDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports